
import React, { useEffect, useState } from 'react';
import './App.css';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { initI18n } from './locales/i18n';

import Header from './nav/Header';

import BlockScreen from './components/Unlock/BlockScreen';
import CreateWallet from './components/Create/CreateWallet';
import CreateManualWallet from './components/Create/CreateManualWallet';
import WalletProtection from './components/Create/WalletProtection';
import SecretPhraseGeneration from './components/Create/SecretPhraseGeneration';
import SecretPhraseWarning from './components/Create/SecretPhraseWarning';
import SecretPhraseConfirmation from './components/Create/SecretPhraseConfirmation';
import SecretPhraseCheck from './components/Create/SecretPhraseCheck';
import WalletRecovery from './components/Restore/WalletRecovery';
import WalletQssRecovery from './components/Restore/WalletQssRecovery';
import WalletRecoveryProtection from './components/Restore/WalletRecoveryProtection';
import WalletRecoveryLoading from './components/Restore/WalletRecoveryLoading';
import WalletRecoveryComplete from './components/Restore/WalletRecoveryComplete';
import WalletCreationLoading from './components/Create/Complete/WalletCreationLoading';
import WalletCreationComplete from './components/Create/Complete/WalletCreationComplete';
import BalanceScreen from './components/Balance/BalanceScreen';
import useSecureStorage from './hooks/useSecureStorage';
import WalletScreen from './components/Wallet/WalletScreen';
import WalletScreenDetail from './components/Wallet/WalletScreenDetail';
import SeeMoreScreen from './components/More/SeeMoreScreen';
import SecuritySettings from './components/More/Security/SecuritySettings';
import ChangePassword from './components/More/Security/ChangePassword';
import SecuritySecretPhraseWarning from './components/More/Security/SecuritySecretPhraseWarning';
import SecuritySecretPhraseConfirmation from './components/More/Security/SecuritySecretPhraseConfirmation';
import LanguageSettingsScreen from './components/More/Language/LanguageSettingsScreen';
import TokenList from './components/More/TokenList';
import QssSettingMnemonicScreen from './components/More/Qss/QssSettingMnemonicScreen';
import QssSettingMnemonicPassword from './components/More/Qss/QssSettingMnemonicPassword';
import QssSettingMnemonicProcess from './components/More/Qss/QssSettingMnemonicProcess';
import QssSettingDataList from './components/Qss/QssSettingDataList';
import QssSettingSecretPhraseWarning from './components/More/Qss/QssSettingSecretPhraseWarning';
import QssSettingSecretPhraseConfirmation from './components/More/Qss/QssSettingSecretPhraseConfirmation';
import QssSettingWalletAddressScreen from './components/More/Qss/QssSettingWalletAddressScreen';
import QssSettingWalletAddressAdd from './components/More/Qss/QssSettingWalletAddressAdd';

import WithdrawScreen from './components/Balance/WithdrawScreen';
import WithdrawCompleteScreen from './components/Balance/WithdrawCompleteScreen';
import ReceiveScreen from './components/Balance/ReceiveScreen';
import UnlockScreen from './components/Unlock/UnlockScreen';
import ResetWalletScreen from './components/Unlock/ResetWalletScreen';

import QssCreateWalletProtection from './components/Qss/QssCreateWalletProtection';
import QssCreateSecretPhraseWarning from './components/Qss/QssCreateSecretPhraseWarning';
import QssCreateSecretPhraseConfirmation from './components/Qss/QssCreateSecretPhraseConfirmation';
import QssNewPassword from './components/Qss/QssNewPassword';
import QssPassword from './components/Qss/QssPassword';
import QssSaveProcess from './components/Qss/QssSaveProcess';
import QssLoadPassword from './components/Qss/QssLoadPassword';
import QssLoadProcess from './components/Qss/QssLoadProcess';
import QssLoadDataList from './components/Qss/QssLoadDataList';

import BuyerScreen from './components/Buyer/BuyerScreen';
import SellerScreen from './components/Seller/SellerScreen';

import WebApp from '@twa-dev/sdk'
import { BackButton } from '@twa-dev/sdk/react';

import { useSelector } from 'react-redux';
import { RootState } from './store';

import { ThemeProvider } from './context/ThemeContext';

// Network Context
import { SolanaProvider } from './context/SolanaContext';
import { BscProvider } from './context/BscContext';
import { TonProvider } from './context/TonContext';
import { NetworkProvider } from './context/NetworkContext';

import { DefaultTokenProvider } from './context/DefaultTokenContext';
import { SetupProvider } from './context/SetupContext';

// 릴리즈모드 console.log 비활성
if (process.env.REACT_APP_NODE_ENV !== 'development') {
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
}

const App: React.FC = () => {
  let location = useLocation();
  let navigate = useNavigate();

  const [isI18nInitialized, setI18nInitialized] = useState<boolean>(false); // i18n 초기화 상태
  const [loca, setLoca] = useState<boolean>(true)
  const [isUnlocked, setIsUnlocked] = useState<boolean>(false);
  const [isRegister, setIsRegister] = useState<boolean>(false);

  const { getLogin } = useSecureStorage()

  let unlockState: any = useSelector((state: RootState) => state.unlock);

  useEffect(() => {
    if (location.pathname === '#') setLoca(false)
    else if (location.pathname === '/') setLoca(false)
    else if (location.pathname === '/CreateWallet') setLoca(false)
    else if (location.pathname === '/UnlockScreen') setLoca(false)
    else if (location.pathname === '/BalanceScreen') setLoca(false)
    else if (location.pathname === '/BuyerScreen') setLoca(false)
    else if (location.pathname === '/SellerScreen') setLoca(false)
    else if (location.pathname === '/WalletScreen') setLoca(false)
    else if (location.pathname === '/PaymentScreen') setLoca(false)
    else if (location.pathname === '/NFTScreen') setLoca(false)

    else if (location.pathname === '/WithdrawScreen') setLoca(false)
    else if (location.pathname === '/ReceiveScreen') setLoca(false)

    else setLoca(true)
  }, [location])

  // 지갑 생성이 완료된 경우 BalanceScreen 으로 보냄
  useEffect(() => {
    const initializeI18n = async () => {
      await initI18n();
      setI18nInitialized(true); // 초기화가 완료되면 상태 업데이트

      const platform = WebApp.platform
      // 지정된 플랫폼 환경이 아니면 block 화면으로 이동
      if ('android' !== platform &&
        'android_x' !== platform &&
        'ios' !== WebApp.platform &&
        'tdesktop' !== WebApp.platform &&
        'macos' !== WebApp.platform) {
        setLoca(false)
        navigate(`/BlockScreen`, { replace: true, state: {} });
        return
      }
    };


    initializeI18n();
    // checkLockStatus()
  }, [])

  useEffect(() => {
    const initializeTgApi = async () => {
      console.log(`App.tsx 텔레그램 플랫폼 : ${WebApp.platform}`)
      await initTgPlatform()
    };

    initializeTgApi()
  }, [location]);

  // 텔레그램 WebApp 초기화
  const initTgPlatform = async () => {
    try {
      console.log(`App.tsx 텔레그램 플랫폼 : ${WebApp.platform}`)
      const platform = WebApp.platform

      if ('android' !== platform &&
        'android_x' !== platform &&
        'ios' !== WebApp.platform &&
        'tdesktop' !== WebApp.platform &&
        'macos' !== WebApp.platform) {
        setLoca(false)
        return
      }

      if ('android' === platform || 'android_x' === platform || 'ios' === WebApp.platform) {
        if (false === WebApp.BiometricManager.isInited) {
          WebApp.expand()

          WebApp.BiometricManager.init(TgWebAppBioInitApiCallBack)
        } else {
          await checkUnlockStatus()
        }
      } else {
        await checkUnlockStatus()
      }

      WebApp.ready()

    } catch (error) {
      console.error(`App.tsx initTgPlatform error`, error)
    }
  }

  // 텔레그램 생체인증 시작
  const TgWebAppBioInitApiCallBack = async () => {
    checkUnlockStatus()
    WebApp.ready()

    // WebApp.expand()
  }

  const checkUnlockStatus = async () => {
    const fullPath = location.pathname + location.hash

    console.log(`//------------------------------`)
    console.log(`App.tsx unlockState`, unlockState.value)

    if (true === unlockState.value) {
      setIsUnlocked(true);
    } else {
      setIsUnlocked(false);
    }

    checkUnlock(fullPath)

    const platform = WebApp.platform

    if (fullPath === '/BalanceScreen' ||
      fullPath === '/CreateWallet' ||
      fullPath === '/UnlockScreen'
    ) {
      // BalanceScreen으로 들어오면 텔레그램 백 버튼 숨김 (닫기 버튼으로 변경됨)
      if ('android' === platform || 'android_x' === platform || 'ios' === platform || 'tdesktop' === platform) {
        WebApp.BackButton.hide();
      }
    } else {
      // 텔레그램 미니앱의 백 버튼 표시
      if ('android' === platform || 'android_x' === platform || 'ios' === platform || 'tdesktop' === platform) {
        WebApp.BackButton.show();
      }
    }
  }

  // const checkLockStatus = async () => {
  //   console.log(`checkLockStatus`) 

  //   setIsUnlocked(true);
  //   checkLogin()
  // };

  // const checkLogin = async () => {
  //   const loginStatus = await getLogin()

  //   console.log(`checkLogin 지갑 등록 상태 : ${loginStatus}`)
  //   console.log(`checkLogin 잠금해제 상태 isUnlocked : ${isUnlocked}`)
  //   if (true === loginStatus) {
  //     // 지갑 등록 상태
  //     // 언락 상태 확인
  //     setIsRegister(loginStatus)
  //     if (false == isUnlocked) {
  //       // 잠금 상태이면 UnlockScreen 으로 이동
  //       console.log(`지갑 잠금해제 상태 1 : ${isUnlocked}`)
  //       navigate(`/`)
  //     } else {
  //       // 언락 상태이면 BalanceScreen 으로 이동
  //       console.log(`지갑 잠금해제 상태 2 : ${isUnlocked}`)
  //       navigate(`BalanceScreen`)
  //     }
  //   } else {
  //     // 지갑 등록 상태가 아니라면
  //     // 지갑 생성 페이지로 이동
  //     console.log(`지갑 등록 상태 3 : ${loginStatus}`)
  //     navigate(`CreateWallet`)
  //   }

  //   return loginStatus;
  // }

  // 언락상태 확인
  const checkUnlock = async (location: string) => {
    const loginStatus = await getLogin()
    setIsRegister(loginStatus)

    const unlockStatus = unlockState.value;

    console.log(`App.tsx checkUnlock location : ${location} | loginStatus : ${loginStatus} | isRegister : ${isRegister} | isUnlocked : ${unlockStatus}`)

    if (false === loginStatus) {
      // 지갑 등록이 되지 않은 상태
      if ('/CreateWallet' !== location &&
        '/CreateManualWallet' !== location &&
        '/WalletProtection' !== location &&
        '/SecretPhraseGeneration' !== location &&
        '/SecretPhraseWarning' !== location &&
        '/SecretPhraseConfirmation' !== location &&
        '/SecretPhraseCheck' !== location &&
        '/WalletRecovery' !== location &&
        '/WalletQssRecovery' !== location &&
        '/WalletRecoveryProtection' !== location &&
        '/WalletRecoveryLoading' !== location &&
        '/WalletRecoveryComplete' !== location &&
        '/WalletCreationLoading' !== location &&
        '/WalletCreationComplete' !== location &&

        '/QssCreateWalletProtection' !== location &&
        '/QssCreateSecretPhraseWarning' !== location &&
        '/QssCreateSecretPhraseConfirmation' !== location &&
        '/QssNewPassword' !== location &&
        '/QssPassword' !== location &&
        '/QssSaveProcess' !== location &&
        '/QssLoadPassword' !== location &&
        '/QssLoadProcess' !== location &&
        '/QssLoadDataList' !== location &&

        '/BlockScreen' !== location
      ) {
        navigate('/CreateWallet');
      }
    }
    else if (true === loginStatus && false === unlockStatus) {
      // 지갑 등록 되고 잠금 상태
      if ('/' !== location && '/UnlockScreen' !== location && '/ResetWalletScreen' !== location) {
        // UnlockScreen 이외 페이지로 이동 불가
        navigate('/UnlockScreen');
      }
    }
    else if (true === loginStatus && true === unlockStatus) {
      // 지갑 등록 되고 언락 상태
      if ('/BalanceScreen' !== location &&
        '/BuyerScreen' !== location &&
        '/SellerScreen' !== location &&
        '/WalletScreen' !== location &&
        '/WalletScreenDetail' !== location &&
        '/SeeMoreScreen' !== location &&
        '/SecuritySettings' !== location &&
        '/ChangePassword' !== location &&
        '/SecuritySecretPhraseWarning' !== location &&
        '/SecuritySecretPhraseConfirmation' !== location &&
        '/LanguageSettingsScreen' !== location &&
        '/TokenList' !== location &&
        '/QssSettingMnemonicScreen' !== location &&
        '/QssSettingMnemonicPassword' !== location &&
        '/QssSettingMnemonicProcess' !== location &&
        '/QssSettingDataList' !== location &&
        '/QssSettingSecretPhraseWarning' !== location &&
        '/QssSettingSecretPhraseConfirmation' !== location &&
        '/QssSettingWalletAddressScreen' !== location &&
        '/QssSettingWalletAddressAdd' !== location &&

        '/WithdrawScreen' !== location &&
        '/WithdrawCompleteScreen' !== location &&
        '/ReceiveScreen' !== location &&
        '/QssCreateWalletProtection' !== location &&
        '/QssCreateSecretPhraseWarning' !== location &&
        '/QssCreateSecretPhraseConfirmation' !== location &&
        '/QssNewPassword' !== location &&
        '/QssPassword' !== location &&
        '/QssSaveProcess' !== location &&
        '/QssLoadPassword' !== location &&
        '/QssLoadProcess' !== location &&
        '/QssLoadDataList' !== location &&

        '/BlockScreen' !== location
      ) {
        navigate('/BalanceScreen');
      }
      else {
      }

    }
  }

  // 텔레그램 backbutton 처리
  const handleTgBackButton = async () => {
    const fullPath = location.pathname + location.hash
    if ('/BalanceScreen' !== fullPath && '/CreateWallet' !== fullPath) {
      // 홈화면, 지갑생성 시작 화면 이 아닌 경우는 이전 페이지로 이동
      navigate(-1)
    } else {
      // WebApp.close()
    }
  };

  // i18n 초기화가 완료되기 전에는 로딩 화면을 표시
  if (!isI18nInitialized) {
    // return <div>Loading translations...</div>;
    console.log(`Loading translations`)
    return <div></div>;
  }


  // 뷰포트 변경 이벤트 핸들러 등록
  // WebApp.onEvent("viewportChanged", () => {
  //   console.log(`WebApp.isExpanded : ${WebApp.isExpanded}`)

  //   if (true == WebApp.isExpanded) {
  //     console.log("미니앱이 축소되었습니다.");
  //     // 미니앱이 축소된 상태에서 필요한 동작 수행
  //     // 잠금상태로 전환
  //     setIsUnlocked(false);
  //   } else {
  //     console.log("미니앱이 확장되었습니다.");
  //     // 미니앱이 확장된 상태에서 필요한 동작 수행
  //   }
  // });

  return (
    <ThemeProvider>
      <DefaultTokenProvider>
        <SetupProvider>
          <SolanaProvider>
            <BscProvider>
              <TonProvider>
                <NetworkProvider>

                  <div className='App'>
                    <BackButton onClick={() => handleTgBackButton()} />
                    {loca && (<Header />)}
                    <Routes>
                      <Route path="/" element={<UnlockScreen />} />
                      <Route path="/BlockScreen" element={<BlockScreen />} />
                      <Route path="/UnlockScreen" element={<UnlockScreen />} />
                      <Route path="/ResetWalletScreen" element={<ResetWalletScreen />} />
                      <Route path="/CreateManualWallet" element={<CreateManualWallet />} />
                      <Route path="/CreateWallet" element={<CreateWallet />} />
                      <Route path="/WalletProtection" element={<WalletProtection />} />
                      <Route path="/SecretPhraseGeneration" element={<SecretPhraseGeneration />} />
                      <Route path="/SecretPhraseWarning" element={<SecretPhraseWarning />} />
                      <Route path="/SecretPhraseConfirmation" element={<SecretPhraseConfirmation />} />
                      <Route path="/SecretPhraseCheck" element={<SecretPhraseCheck />} />
                      <Route path="/WalletRecovery" element={<WalletRecovery />} />
                      <Route path="/WalletQssRecovery" element={<WalletQssRecovery />} />
                      <Route path="/WalletRecoveryProtection" element={<WalletRecoveryProtection />} />
                      <Route path="/WalletRecoveryLoading" element={<WalletRecoveryLoading />} />
                      <Route path="/WalletRecoveryComplete" element={<WalletRecoveryComplete />} />
                      <Route path="/WalletCreationLoading" element={<WalletCreationLoading />} />
                      <Route path="/WalletCreationComplete" element={<WalletCreationComplete />} />
                      <Route path="/BalanceScreen" element={<BalanceScreen />} />
                      <Route path="/WalletScreen" element={<WalletScreen />} />
                      <Route path="/WalletScreenDetail" element={<WalletScreenDetail />} />
                      <Route path="/SeeMoreScreen" element={<SeeMoreScreen />} />
                      <Route path="/SecuritySettings" element={<SecuritySettings />} />
                      <Route path="/ChangePassword" element={<ChangePassword />} />
                      <Route path="/SecuritySecretPhraseWarning" element={<SecuritySecretPhraseWarning />} />
                      <Route path="/SecuritySecretPhraseConfirmation" element={<SecuritySecretPhraseConfirmation />} />
                      <Route path="/LanguageSettingsScreen" element={<LanguageSettingsScreen />} />
                      <Route path="/TokenList" element={<TokenList />} />

                      <Route path="/QssSettingMnemonicScreen" element={<QssSettingMnemonicScreen />} />
                      <Route path="/QssSettingMnemonicPassword" element={<QssSettingMnemonicPassword />} />
                      <Route path="/QssSettingMnemonicProcess" element={<QssSettingMnemonicProcess />} />
                      <Route path="/QssSettingDataList" element={<QssSettingDataList />} />
                      <Route path="/QssSettingSecretPhraseWarning" element={<QssSettingSecretPhraseWarning />} />
                      <Route path="/QssSettingSecretPhraseConfirmation" element={<QssSettingSecretPhraseConfirmation />} />
                      <Route path="/QssSettingWalletAddressScreen" element={<QssSettingWalletAddressScreen />} />
                      <Route path="/QssSettingWalletAddressAdd" element={<QssSettingWalletAddressAdd />} />

                      <Route path="/WithdrawScreen" element={<WithdrawScreen />} />
                      <Route path="/WithdrawCompleteScreen" element={<WithdrawCompleteScreen />} />
                      <Route path="/ReceiveScreen" element={<ReceiveScreen />} />
                      <Route path="/QssCreateWalletProtection" element={<QssCreateWalletProtection />} />
                      <Route path="/QssCreateSecretPhraseWarning" element={<QssCreateSecretPhraseWarning />} />
                      <Route path="/QssCreateSecretPhraseConfirmation" element={<QssCreateSecretPhraseConfirmation />} />
                      <Route path="/QssNewPassword" element={<QssNewPassword />} />
                      <Route path="/QssPassword" element={<QssPassword />} />
                      <Route path="/QssSaveProcess" element={<QssSaveProcess />} />
                      <Route path="/QssLoadPassword" element={<QssLoadPassword />} />
                      <Route path="/QssLoadProcess" element={<QssLoadProcess />} />
                      <Route path="/QssLoadDataList" element={<QssLoadDataList />} />

                      <Route path="/BuyerScreen" element={<BuyerScreen />} />
                      <Route path="/SellerScreen" element={<SellerScreen />} />

                    </Routes>
                  </div>

                </NetworkProvider>
              </TonProvider>
            </BscProvider>
          </SolanaProvider>
        </SetupProvider>
      </DefaultTokenProvider>
    </ThemeProvider>
  );
};

export default App;